// ─────────────────────────────────────────────
//  ErrorBoundary — catches a render/runtime error in the tree below it so a
//  single bad component can't freeze the whole app (the screen would otherwise
//  show a dead last frame). Shows the error + a reload button, and logs it.
// ─────────────────────────────────────────────
import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("App crashed:", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={st.wrap} role="alert">
        <div style={st.card}>
          <div style={st.title}>Something went wrong.</div>
          <div style={st.body}>The screen hit an error. Reload to continue.</div>
          <pre style={st.pre}>{String(this.state.error?.message || this.state.error)}</pre>
          <button style={st.btn} onClick={() => window.location.reload()}>Reload</button>
        </div>
      </div>
    );
  }
}

const st = {
  wrap: { position: "fixed", inset: 0, zIndex: 5000, display: "flex", alignItems: "center", justifyContent: "center", background: "#0b1020", padding: 20, fontFamily: "system-ui, sans-serif" },
  card: { background: "#fff", borderRadius: 12, padding: 28, maxWidth: 520, width: "100%", boxShadow: "0 12px 40px rgba(0,0,0,.3)" },
  title: { fontSize: 20, fontWeight: 800, color: "#1e293b", marginBottom: 8 },
  body: { fontSize: 14, color: "#475569", marginBottom: 14 },
  pre: { fontSize: 12, color: "#b91c1c", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 12px", whiteSpace: "pre-wrap", wordBreak: "break-word", marginBottom: 16, maxHeight: 200, overflow: "auto" },
  btn: { background: "#1e40af", color: "#fff", border: "none", borderRadius: 8, padding: "10px 18px", fontSize: 14, fontWeight: 700, cursor: "pointer" },
};
